import { Record } from 'immutable';

const defaultValues = {
  loading: false,
  errorMessage: null,
  domElement: null,
  productDefinition: null,
  configuration: null,
};

export default class Canvas extends Record(defaultValues, Canvas) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
